export function getQueryParam(key = "") {
  const param = new URL(window.location.href).searchParams.get(key);
  if (param === "false" || param === null) {
    return false;
  }
  if (param === "true" || param === "") {
    return true;
  }
  return param;
}
